<template>
  <component :is="cmp" :options="options" :utm-source="UtmSource" />
</template>
<script lang="ts">
import i18n from '@/i18n'
import {
  onBeforeMount,
  getCurrentInstance,
  ref,
  watch,
  computed,
  defineComponent,
} from 'vue'
import { isMobile, getUtmSource } from '@util/index'
import useStore from '@src/hooks/useStore'
export default defineComponent({
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const vm = getCurrentInstance()
    const cmp = ref('')
    const UtmSource = ref('')
    const pcCmp = ref('')
    const mobileCmp = ref('')
    const store = useStore(vm)
    const adminState = computed(() => store.state.user.USER_isAdmin)
    watch(adminState, function (newVal) {
      if (!newVal) {
        window.logic.report('register_show', i18n.t('d8852ffc9c'))
        store.dispatch('AdminModal', true)
      }
    })
    const setLoadComponent = (pc, mobile) => {
      pcCmp.value !== pc && (pcCmp.value = pc)
      mobileCmp.value !== mobile && (mobileCmp.value = mobile)
      if (mobile) {
        if (isMobile()) {
          window.logic.report('register_show', i18n.t('8a733a2574'))
          cmp.value = mobile
        } else {
          window.logic.report('register_show', i18n.t('9e8c152c4f'))
          cmp.value = pc
        }
      } else {
        window.logic.report('register_show', i18n.t('9e8c152c4f'))
        cmp.value = pc
      }
    }
    const setTitle = (title: string) => {
      store.dispatch('HeadTitle', title || '')
    }
    onBeforeMount(() => {
      UtmSource.value = getUtmSource() as string
    })
    return {
      cmp,
      UtmSource,
      setLoadComponent,
      setTitle,
    }
  },
})
</script>
